<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <!-- Title page  -->
            <h1 class="page__title justify-content">{{ $t(titlePage) }}</h1>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">
                <CRow class="justify-content-end p-2 m-0">
                    <CCol md="5">
                        <!-- Filter -->
                        <FilterDate @updateData="updateData" />
                    </CCol>
                </CRow>
                <CRow class="p-2 m-0">
                    <CCol md="12" sm="12">
                        <!-- Filter -->
                        <FilterFields
                            :fields="tables.deliveryPending.fields"
                            @filter="updateData"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol xl="12" md="12" class="mb-4">
                        <CCard>
                            <CCardHeader>
                                <!-- Button back -->
                                <div class="d-flex">
                                    <ButtonBack class="mr-3" />
                                    <TableSettings
                                        :allFields="
                                            tables.deliveryPending.allFields
                                        "
                                        :activeFields.sync="
                                            tables.deliveryPending.fields
                                        "
                                    />
                                </div>
                            </CCardHeader>
                            <CCardBody>
                                <h6>
                                    {{ $t("leads_received_description") }}
                                </h6>
                                <CDataTable
                                    :addTableClasses="['table--sm']"
                                    :items="tables.deliveryPending.items"
                                    :fields="
                                        traslateArrayObjects({
                                            array: tables.deliveryPending
                                                .fields,
                                            fields: ['label'],
                                        })
                                    "
                                    :columnFilterValue.sync="
                                        tables.deliveryPending.columnFilterValue
                                    "
                                    @update:column-filter-value="updateData()"
                                    @pagination-change="itemPerPage"
                                    :items-per-page="
                                        tables.deliveryPending.rows
                                    "
                                    v-bind="tables.deliveryPending"
                                >
                                    <template #over-table>
                                        <div
                                            class="d-flex justify-content-between"
                                        >
                                            <CDropdown
                                                color="primary"
                                                :toggler-text="$t('actions')"
                                                class="m-2"
                                            >
                                                <CDropdownItem
                                                    tag="div"
                                                    :disabled="
                                                        !hasLeadsSelected
                                                    "
                                                    @click="
                                                        actionSendDeliveryPendingSelected()
                                                    "
                                                >
                                                    {{ $t("Send leads") }}
                                                </CDropdownItem>
                                                <CDropdownItem
                                                    tag="div"
                                                    :disabled="
                                                        !hasLeadsSelected
                                                    "
                                                    @click="
                                                        openModal({
                                                            modalName:
                                                                'sendLeadsToDeliveryCampaignWithTrollingDelivery',
                                                            data: {
                                                                leads: getLeadsSelected(),
                                                                deliveryCampaignId:
                                                                    getLeadsSelected()[0]
                                                                        .deliveryCampaignId,
                                                            },
                                                        })
                                                    "
                                                >
                                                    {{
                                                        $t(
                                                            "Send leads with throttling delivery"
                                                        )
                                                    }}
                                                </CDropdownItem>
                                            </CDropdown>
                                            <CButton
                                                class="m-2"
                                                color="primary"
                                                variant="outline"
                                                @click="
                                                    openModalSendAllDeliveryPendingsWithDeliveryThrolling()
                                                "
                                            >
                                                Send Throlling Delivery
                                            </CButton>
                                        </div>
                                    </template>
                                    <template #_selected-header>
                                        <CInputCheckbox
                                            :checked.sync="checkboxSelectAllItems"
                                            @update:checked="selectAll"
                                        />
                                    </template>
                                    <template #_selected="{ index }">
                                        <td class="py-2">
                                            <CInputCheckbox
                                                :checked.sync="
                                                    tables.deliveryPending
                                                        .items[index]._selected
                                                "
                                            />
                                        </td>
                                    </template>
                                    <template #under-table>
                                        <div class="d-flex justify-content-end">
                                            <ButtonExport
                                                :endPoint="
                                                    '/campaigns.api/' +
                                                    uuid +
                                                    '/pendings'
                                                "
                                                :table="tables.deliveryPending"
                                            />
                                        </div>
                                    </template>
                                </CDataTable>
                            </CCardBody>
                            <CCardFooter
                                v-if="tables.deliveryPending.total_pages > 0"
                            >
                                <div class="position-relative">
                                    <CPagination
                                        @update:activePage="updatePagination"
                                        :activePage="
                                            tables.deliveryPending.page
                                        "
                                        :pages="
                                            tables.deliveryPending.total_pages
                                        "
                                        align="center"
                                    />
                                    <CElementCover
                                        :opacity="0.8"
                                        class="bg-trasparent"
                                        v-if="tables.deliveryPending.loading"
                                    />
                                </div>
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
        <CCDeliveryPendingsWithThrollingDeliveryModal
            v-bind="modals.sendLeadsToDeliveryCampaignWithTrollingDelivery"
            :leads="
                modals.sendLeadsToDeliveryCampaignWithTrollingDelivery.data
                    .leads
            "
            :deliveryCampaignId="
                modals.sendLeadsToDeliveryCampaignWithTrollingDelivery.data
                    .deliveryCampaignId
            "
            :show.sync="
                modals.sendLeadsToDeliveryCampaignWithTrollingDelivery.show
            "
            v-on:submit="resetLeadsSelected"
        />
    </CCard>
</template>

<script>
/**
 * Components
 */
import ButtonExport from "~/components/ButtonExport";
import ButtonBack from "£lement/ButtonBack";
import FilterDate from "~/components/FilterDate";
import TableSettings from "£lement/TableSettings";
import FilterFields from "~/components/FilterFields";
/**
 * Mixins
 */
import pageMixin from "~/mixins/page.js";
import tableMixin from "~/mixins/table.js";

/**
 * Others
 */
import axios from "axios";
import {
    cilPlus,
    cilSettings,
    cilPencil,
    cilTrash,
    cilArrowThickFromRight,
} from "@coreui/icons";
import { mapGetters } from "vuex";
import DeliveryPendingTable from "./config/tables/delivery_pending.js";
import CCDeliveryPendingsWithThrollingDeliveryModal from "~/components/CCDeliveryPendingsWithThrollingDeliveryModal";

import modalMixin from "~/mixins/modal";

export default {
    name: "DeliveryPendingPage",
    middleware: ["auth", "page"],
    mixins: [pageMixin, tableMixin, modalMixin],
    components: {
        FilterDate,
        TableSettings,
        ButtonBack,
        ButtonExport,
        FilterFields,
        CCDeliveryPendingsWithThrollingDeliveryModal,
    },
    icons: {
        cilPlus,
        cilSettings,
        cilPencil,
        cilTrash,
        cilArrowThickFromRight,
    },
    data() {
        return {
            tables: {
                deliveryPending: DeliveryPendingTable,
            },
            modals: {
                sendLeadsToDeliveryCampaignWithTrollingDelivery: {
                    show: false,
                    color: "primary",
                    title: "Send with throttling delivery",
                    data: {
                        leads: [],
                    },
                },
            },
            checkboxSelectAllItems: false,
        };
    },
    computed: {
        ...mapGetters({
            from: "filter/from",
            to: "filter/to",
        }),

        hasLeadsSelected() {
            return this.getLeadsSelected().length > 0;
        },

        uuid: function () {
            return this.$route.params.uuid;
        },
    },
    methods: {
        async updateData() {
            await this.updateTable({
                tableName: "deliveryPending",
                url: `/campaigns.api/${this.uuid}/pendings`,
                customFields: {
                    _selected: false,
                },
            });

            this.tables.deliveryPending.allFields =
                this.getTableAllFields("deliveryPending");
            
            this.checkboxSelectAllItems = false;
            this.$store.dispatch("page/updateLoading", {
                loading: false,
            });
        },

        getLeadsSelected() {
            return this.tables.deliveryPending.items
                .filter((item) => item._selected)
                .map((item) => {
                    return {
                        id: item.lead_id,
                        uuidSendingRef: item.uuid_sending_ref,
                        deliveryCampaignId: parseInt(item.client_id),
                    };
                });
        },

        async getLeadsInAllPages() {
            const tableName = "deliveryPending";
            // this.tables[tableName].loading = true;
            let table = {
                ...this.tables[tableName],
                rows: null,
                // dateFieldFilter: "CreatedAtDate",
                // orderField: "LeadId",
                // matchResponse: "data.items",
                // matchResponseCurrentPage: "data.currentPage",
                // matchResponsePages: "data.pages",
            };
            const data = await this.loadTable({
                table,
                // baseURL: process.env.VUE_APP_API_SASS,
                url: `/campaigns.api/${this.uuid}/pendings`,
            });

            // console.log({ leadIds: data.items.map((item) => item.LeadId) });

            return data.items.map((item) => {
                return {
                    id: item.lead_id,
                    uuidSendingRef: item.uuid_sending_ref,
                    deliveryCampaignId: parseInt(item.client_id),
                };
            });
        },

        async openModalSendAllDeliveryPendingsWithDeliveryThrolling() {
            try {
                this.updatePageLoading(true);
                const leads = await this.getLeadsInAllPages();
                this.openModal({
                    modalName:
                        "sendLeadsToDeliveryCampaignWithTrollingDelivery",
                    data: {
                        leads,
                        deliveryCampaignId: leads[0].deliveryCampaignId,
                    },
                });
                // this.updateData();
                // this.showMessageSuccess();
            } catch (error) {
                // this.showMessageError(error);
            } finally {
                this.updatePageLoading(false);
            }
        },

        resetLeadsSelected() {
            this.tables.deliveryPending.items.map(
                (item) => (item._selected = false)
            );
            this.updateData();
        },

        async sendDeliveryPendingsSelectedWithThrolling() {
            let itemsSelected = this.tables.deliveryPending.items.filter(
                (item) => item._selected
            );

            itemsSelected = itemsSelected.map((item) => item.id);
            if (itemsSelected.length <= 0) {
                return false;
            }
            try {
                const { data } = await axios.post(
                    "/outgoing.api/pending_delivery",
                    itemsSelected
                );
                this.updateData();
                this.showMessageByMethod("POST");
            } catch (error) {
                this.showMessageError(error);
            }
        },

        async actionSendDeliveryPendingSelected() {
            let itemsSelected = this.tables.deliveryPending.items.filter(
                (item) => item._selected
            );

            itemsSelected = itemsSelected.map((item) => item.id);
            if (itemsSelected.length <= 0) {
                return false;
            }
            try {
                const { data } = await axios.post(
                    "/outgoing.api/pending_delivery",
                    itemsSelected
                );
                this.updateData();
                this.showMessageByMethod("POST");
            } catch (error) {
                this.showMessageError(error);
            }
        },

        selectAll(checked) {
            this.tables.deliveryPending.items.forEach((item) => {
                item._selected = checked;
            });
        },
    },
    mounted() {
        this.updateData();
    },
};
</script>

<style scoped lang="scss"></style>
